<template>
  <v-layout justify-center>
    <v-dialog width="1200px" v-model="show_error_dialog" persistent max-width="800">
      <error-message :required_empty_fields="required_empty_fields" :errors="errors" @closeDialog="closeDialog" />
    </v-dialog>
  </v-layout>
</template>

<script>
import AdminPartnerCreateErrorMessage from "./AdminPartnerCreateErrorMessage"

export default {
  name: 'AdminPartnerCreateErrorMessageDialog',
  components: { 
    'error-message': AdminPartnerCreateErrorMessage
  },
  props: {
    required_empty_fields: {
      type: Array
    },
    show_error_dialog: {
      type: Boolean
    },
    errors:{
      type: Object
    }
  },
  data(vm) {
    return {
      opening: false
    }
  },
  watch: {
    show_error_dialog (val) {
      if (val == false) {
      } else {
        this.opening = true
        setTimeout(function(){
          this.$nextTick(function () {
            this.opening = false
          })
        }.bind(this), 500)
      }
    },
  },
  methods: {
    closeDialog(step) {
      if(this.show_error_dialog) this.$emit('closeDialog', step)
    }
  },
  computed: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/AdminPartnerCreateErrorMessageDialog.vue